import {
  UseMutationResult,
  useQueryClient,
  useMutation,
} from '@tanstack/react-query';
import { axiosInstance } from 'hooks/auth/AxiosInstance';
interface AddOffence {
  name: string;
  isSlabRateApplicable: '' | 'Y' | 'N';
  offenceLabel: string;
  actSection: string;
  amount: number;
}
const addOffence = async (data: AddOffence) => {
  const response = await axiosInstance.post('/offence', data);
  return response.data;
};

const useAddOffence = (): UseMutationResult<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  Error,
  AddOffence
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: addOffence,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['offence'] });
      queryClient.invalidateQueries({ queryKey: ['offences'] });
    },
    onError: (error: Error) => {
      console.error('Error adding offence:', error.message);
    },
  });
};

export default useAddOffence;
